/**
 * Whether the Live Stream / Split View tabs (and the Site Video Wall) should be
 * offered for an alert. The alerts API carries `live_streaming_site_enabled`
 * (Customer.live_streaming_enabled, the flag the stream mint gates on) per
 * alert; a site with it off can only ever answer "Live View not Available",
 * so the tabs are pointless there.
 *
 * Only an explicit `false` hides them. A missing/null flag is "unknown"
 * (older API), and unknown is not "off". The user-level gate (LaunchDarkly
 * flag + live_streaming permission) is checked by the caller.
 */
export const isLiveStreamingAvailableForAlert = (
  row: { live_streaming_site_enabled?: boolean | null } | null | undefined
): boolean => row?.live_streaming_site_enabled !== false;
